const SvgOperations2 = (props) => (
  <>
    <path fill={props.p20} d="M31.97 32.01 32 15.45h144.4V160h-16.42l-.01-127.99h-128z" />
    <circle cx={143.99} cy={47.64} r={1} fill="#021d6c" />
    <circle cx={127.99} cy={47.64} r={1} fill="#021d6c" />
    <circle cx={111.99} cy={47.64} r={1} fill="#021d6c" />
    <circle cx={95.99} cy={47.64} r={1} fill="#021d6c" />
    <circle cx={79.99} cy={47.64} r={1} fill="#021d6c" />
    <circle cx={63.99} cy={47.64} r={1} fill="#021d6c" />
    <circle cx={47.99} cy={47.64} r={1} fill="#021d6c" />
    <circle cx={143.99} cy={63.64} r={1} fill="#021d6c" />
    <circle cx={127.99} cy={63.64} r={1} fill="#021d6c" />
    <circle cx={111.99} cy={63.64} r={1} fill="#021d6c" />
    <circle cx={95.99} cy={63.64} r={1} fill="#021d6c" />
    <circle cx={79.99} cy={63.64} r={1} fill="#021d6c" />
    <circle cx={63.99} cy={63.64} r={1} fill="#021d6c" />
    <circle cx={47.99} cy={63.64} r={1} fill="#021d6c" />
    <circle cx={143.99} cy={79.64} r={1} fill="#021d6c" />
    <circle cx={127.99} cy={79.64} r={1} fill="#021d6c" />
    <circle cx={111.99} cy={79.64} r={1} fill="#021d6c" />
    <circle cx={95.99} cy={79.64} r={1} fill="#021d6c" />
    <circle cx={79.99} cy={79.64} r={1} fill="#021d6c" />
    <circle cx={63.99} cy={79.64} r={1} fill="#021d6c" />
    <circle cx={47.99} cy={79.64} r={1} fill="#021d6c" />
    <circle cx={143.99} cy={95.64} r={1} fill="#021d6c" />
    <circle cx={127.99} cy={95.64} r={1} fill="#021d6c" />
    <circle cx={111.99} cy={95.64} r={1} fill="#021d6c" />
    <circle cx={95.99} cy={95.64} r={1} fill="#021d6c" />
    <circle cx={79.99} cy={95.64} r={1} fill="#021d6c" />
    <circle cx={63.99} cy={95.64} r={1} fill="#021d6c" />
    <circle cx={47.99} cy={95.64} r={1} fill="#021d6c" />
    <circle cx={143.99} cy={111.64} r={1} fill="#021d6c" />
    <circle cx={127.99} cy={111.64} r={1} fill="#021d6c" />
    <circle cx={111.99} cy={111.64} r={1} fill="#021d6c" />
    <circle cx={95.99} cy={111.64} r={1} fill="#021d6c" />
    <circle cx={79.99} cy={111.64} r={1} fill="#021d6c" />
    <circle cx={63.99} cy={111.64} r={1} fill="#021d6c" />
    <circle cx={47.99} cy={111.64} r={1} fill="#021d6c" />
    <circle cx={143.99} cy={127.64} r={1} fill="#021d6c" />
    <circle cx={127.99} cy={127.64} r={1} fill="#021d6c" />
    <circle cx={111.99} cy={127.64} r={1} fill="#021d6c" />
    <circle cx={95.99} cy={127.64} r={1} fill="#021d6c" />
    <circle cx={79.99} cy={127.64} r={1} fill="#021d6c" />
    <circle cx={63.99} cy={127.64} r={1} fill="#021d6c" />
    <circle cx={47.99} cy={127.64} r={1} fill="#021d6c" />
    <circle cx={143.99} cy={143.64} r={1} fill="#021d6c" />
    <circle cx={127.99} cy={143.64} r={1} fill="#021d6c" />
    <circle cx={111.99} cy={143.64} r={1} fill="#021d6c" />
    <circle cx={95.99} cy={143.64} r={1} fill="#021d6c" />
    <circle cx={79.99} cy={143.64} r={1} fill="#021d6c" />
    <circle cx={63.99} cy={143.64} r={1} fill="#021d6c" />
    <circle cx={47.99} cy={143.64} r={1} fill="#021d6c" />
    <path fill={props.p30} d="m160 159.99-.03 16.56H15.6V32h16.42l.01 127.99H160z" />
  </>
);

export default SvgOperations2;
